export { default as confirmAction } from './actions/confirm';
